import { render, staticRenderFns } from "./RelatedSubmitalSelector.vue?vue&type=template&id=f655cb9e&"
import script from "./RelatedSubmitalSelector.vue?vue&type=script&lang=js&"
export * from "./RelatedSubmitalSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports